import { createFileRoute } from '@tanstack/react-router';
import { ContactListPage } from '@/components/contact-list';

export const Route = createFileRoute('/sales/customers/')({
  component: () => <ContactListPage kind="customer" />,
});
